const history = [];

export function registerDemoJob(job) {
  const existing = history.find(item => item.id === job.id);
  if (existing) {
    Object.assign(existing, job);
    return;
  }
  history.unshift({
    readAt: null,
    createdAt: new Date().toISOString(),
    payload: {},
    response: null,
    ...job
  });
}

export function markDemoJobRead(id) {
  const job = history.find(item => item.id === id);
  if (job) {
    job.readAt = new Date().toISOString();
  }
}

export function getDemoJobHistory({ limit = 20, skip = 0, job, status } = {}) {
  let filtered = [...history];
  if (job) {
    filtered = filtered.filter(item => item.name === job);
  }
  if (status) {
    filtered = filtered.filter(item => item.status === status);
  }
  return {
    items: filtered.slice(skip, skip + limit),
    total: filtered.length
  };
}
